import moment from 'moment';

const REGION_OFFSETS = {
  AUS: -10,
  US: 8,
  UK: 0,
  SG: -8,
  ASIA_US: -8 // This is Singapore but with USD
};

function getRegionalMoment(region, time) {
  if (!time) {return null;}

  // Default to SG if no region (billingEntityCode) exists against this org
  if (!region) {return time.add(REGION_OFFSETS.SG, 'hours');}

  if (region === 'UK') {return time;}

  time.add(REGION_OFFSETS[region], 'hours');

  return time;
}

export default getRegionalMoment;